/* Funk Firm — scroll progress bar.
 *
 * Creates a 2-px yellow line at the top of the viewport that grows from
 * 0 % to 100 % as the user scrolls through the document. Pure JS, no
 * dependency, idempotent (won't double-mount if the script runs twice).
 *
 * Mount logic: appends a `<div class="funk-scroll-progress">` to <body>
 * on DOMContentLoaded; the CSS in funk-overrides.css controls the visual
 * treatment. Listens to scroll + resize via requestAnimationFrame so the
 * scroll handler stays cheap.
 */
(function () {
  'use strict';

  // Idempotency guard — if the bar was already mounted by an earlier
  // load, don't create another one.
  if (window.__funkScrollProgressMounted) return;
  window.__funkScrollProgressMounted = true;

  function init() {
    var wrap = document.createElement('div');
    wrap.className = 'funk-scroll-progress';
    wrap.setAttribute('aria-hidden', 'true');

    var bar = document.createElement('span');
    bar.className = 'funk-scroll-progress__bar';
    wrap.appendChild(bar);

    document.body.appendChild(wrap);

    var ticking = false;

    function update() {
      var doc = document.documentElement;
      var scrollTop = doc.scrollTop || document.body.scrollTop || 0;
      var scrollMax = (doc.scrollHeight || document.body.scrollHeight) - doc.clientHeight;
      var pct = scrollMax > 0 ? (scrollTop / scrollMax) * 100 : 0;
      // Clamp 0..100 — overscroll bounces can briefly push beyond bounds.
      if (pct < 0) pct = 0;
      if (pct > 100) pct = 100;
      bar.style.width = pct + '%';
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
